import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";
import { Certificate } from "./Certificate";

@Entity({one: "issuedCertificate", many: "issuedCertificates"})
export class IssuedCertificate {

	@Field()
	public id: ID;

	@Field()
	public itemName: string;

	@Field()
	public guid: string;

	@Field({entity: Certificate})
	public certificate: Certificate;

}



// WEBPACK FOOTER //
// ./src/panels/subscriptions/entities/IssuedCertificate.ts